import CustomBreadCrumb from '../../../components/Common/CustomBreadCrumb'
import CreateCargoModal from '../../../components/Purchasing/Packages/CreateCargoModal'
import PackageList from '../../../components/Purchasing/Packages/PackageList'
import PageTitle from '../../../elements/PageTitle'
import { Card, Layout, Row } from 'antd'
import React, { Fragment } from 'react'

const { Content } = Layout

function Package(props) {
  return (
    <Fragment>
      <Content style={{ margin: '0px 0px' }}>
        <Card>
          <Row>
            <CustomBreadCrumb
              items={[
                { text: 'Purchasing' },
                { text: 'Order' },
                { text: 'Delivery', link: '#/purchasing/delivery/list' },
                { text: 'Package', link: '#/purchasing/package/list' },
              ]}
            />
            <PageTitle
              title={'Package'}
              subtitle={'Packages are the items which when combined create the Cargo to be managed. '}
              color={'#427035'}
              iconType={'dropbox'}
            />
          </Row>
        </Card>
        <Row gutter={16} style={{ padding: 10 }}>
          <CreateCargoModal {...props} selection={props.selectionData} />
          <Card>
            <PackageList {...props} />
          </Card>
        </Row>
      </Content>
    </Fragment>
  )
}

Package.propTypes = {}
Package.defaultProps = {}

export default Package
